import { useEffect } from "react";

export function useMount(onMount?: () => void, beforeUnMount?: () => void) {
  useEffect(() => {
    if (onMount) onMount();
    if (beforeUnMount) return beforeUnMount;
  }, []);
}
